import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'
import type { MealCompanyEntity } from './MealCompanyEntity'
import type { MealServiceEntity } from './MealServiceEntity'

export class LiveMealEntity {
  id?: string
  company?: MealCompanyEntity
  service?: MealServiceEntity
  startAt?: string
  lockAt?: string
  companyPeriodTime?: string
  referenceCode?: string | null
  status?: MealStatus
  statusUpdatedAt?: string
  createdAt?: string
  userId?: string | null
  userDisplayName?: string | null
  trackingPanelUserId?: string | null
  trackingPanelUserDisplayName?: string | null
}
